
const digest = '7d81a95e119f39c7371fa5a1b25a03fd506f026492fa1eaf2ea0eec9d68b0028';
const classes = {"wrapper":"_wrapper_1tz0g_1"};
const css = `._wrapper_1tz0g_1 {
  margin: 12px 24px;
  position: relative;
}
._wrapper_1tz0g_1::before {
  content: "";
  width: 10px;
  height: 11px;
  border-left: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  position: absolute;
  left: -14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  